import { Button } from '@mantine/core';
import { isValidElement, ReactElement } from 'react';

import { ApproveRequestAction } from './actions/ApproveRequestAction';
import { HideRequestAction } from './actions/HideRequestAction';
import { RequestActionButtonProps } from './actions/types';
import { useRequestContext } from './RequestProvider';

type Props = {
    children: ReactElement<RequestActionButtonProps> | ReactElement<RequestActionButtonProps>[];
};

export const RequestActions = ({ children: propChildren }: Props) => {
    const children = Array.isArray(propChildren) ? propChildren : [propChildren];
    const { request } = useRequestContext();

    const actionsToShow = children.filter(
        (child) =>
            isValidElement(child)
            && request.currentState
            && (child.props.visibleInStates === request.currentState
                || child.props.visibleInStates?.includes(request.currentState)
                || (child.type === HideRequestAction && !request.isHidden)),
    );
    const buttonGroupActions = actionsToShow.filter((child) => child.type !== ApproveRequestAction);
    const approveRequestAction = actionsToShow.filter((child) => child.type === ApproveRequestAction);

    return (
        <div className="gap-base flex w-full flex-wrap items-center justify-end" style={{ minWidth: 'content' }}>
            <Button.Group>{buttonGroupActions}</Button.Group>
            {approveRequestAction}
        </div>
    );
};
